import { invokeApi } from ".";
import * as endPoints from "../constants/ApiEndpoints";
import { getFromEncLocalStorage } from "../helpers/Utils/Utils";

export const getDetails = async (detailsData) => {
  const token = await getFromEncLocalStorage("token");
  const data = await invokeApi(endPoints.getDetailsApi, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
    payload: detailsData,
  });

  return data;
};

const DetailsService = { getDetails };
export default DetailsService;
